let preloadPromise = null;

export function prefetchDiscoverMap() {
    if (!preloadPromise) {
        preloadPromise = import(
            /* webpackPrefetch: true */
            '../../organisms/Map/OpenStreetMapView'
        ).catch((error) => {
            // Swallow errors to avoid breaking navigation on transient failures.
            console.error('Failed to prefetch Discover map chunk:', error);
            preloadPromise = null;
        });
    }

    return preloadPromise;
}

